import { render, staticRenderFns } from "./onCreditType.vue?vue&type=template&id=cae38df8&scoped=true"
import script from "./onCreditType.vue?vue&type=script&lang=js"
export * from "./onCreditType.vue?vue&type=script&lang=js"
import style0 from "./onCreditType.vue?vue&type=style&index=0&id=cae38df8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae38df8",
  null
  
)

export default component.exports